/* Buton de adaugare rapida in cos pe cardurile de produs.
   - adauga prima varianta disponibila via /cart/add.js
   - reimprospateaza cosul (theme:update:cart)
   - deschide sertarul de cos daca exista; altfel afiseaza un toast
   - feedback pe buton fara diacritice (fontul temei nu le randeaza bine) */
(function () {
  'use strict';

  function addUrl() {
    return (
      (window.theme && window.theme.routes && window.theme.routes.cart_add_url) ||
      '/cart/add'
    );
  }
  function cartUrl() {
    return (
      (window.theme && window.theme.routes && window.theme.routes.cart_url) || '/cart'
    );
  }
  function setLabel(btn, t) {
    if (t == null) return;
    var el = btn.querySelector('.smk-add__label');
    if (el) el.textContent = t;
  }

  // incearca sa deschida sertarul de cos al temei (fara bug-ul cart_type)
  function tryOpenDrawer() {
    document.dispatchEvent(new CustomEvent('theme:open:cart-drawer'));
    try {
      if (window.Alpine && Alpine.store) {
        var modals = Alpine.store('modals');
        if (modals && modals.modals && modals.modals.cart) {
          modals.open('cart');
          return true;
        }
      }
    } catch (e) {}
    return false;
  }

  var toastEl;
  function showToast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'smk-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = '✓ ' + msg;
    var a = document.createElement('a');
    a.href = cartUrl();
    a.textContent = 'Vezi cosul';
    a.className = 'smk-toast__link';
    toastEl.appendChild(span);
    toastEl.appendChild(a);
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 3500);
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest && e.target.closest('[data-smk-add]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      if (btn.classList.contains('is-loading')) return;
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;

      var labelEl = btn.querySelector('.smk-add__label');
      var original = labelEl ? labelEl.textContent : '';

      btn.classList.remove('is-added', 'is-error');
      btn.classList.add('is-loading');
      setLabel(btn, 'Se adauga...');

      fetch(addUrl() + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (d) {
              throw new Error((d && d.description) || 'add_failed');
            });
          }
          return res.json();
        })
        .then(function () {
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          setLabel(btn, 'Adaugat!');
          setTimeout(function () {
            btn.classList.remove('is-added');
            setLabel(btn, original);
          }, 1800);

          document.dispatchEvent(new CustomEvent('theme:update:cart'));
          var opened = tryOpenDrawer();
          if (!opened) showToast('Produs adaugat in cos');
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-error');
          setLabel(btn, 'Eroare');
          setTimeout(function () {
            btn.classList.remove('is-error');
            setLabel(btn, original);
          }, 2200);
          // eslint-disable-next-line no-console
          console.error('[smk-quickadd]', err);
        });
    },
    false
  );
})();
